import { createContext } from '@wordpress/element';
const Context = createContext(false);
Context.displayName = 'DisabledContext';
export default Context;